module.exports = __webpack_public_path__ + "img/stiker_inDrawing.371c0068.png";